export default {
  setIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },
  setIsForceLoading(state, { isForceLoading = false }) {
    state.isForceLoading = isForceLoading;
  },
  setIsOn(state, { isOn = true }) {
    state.isOn = isOn;
  },
  setIsFocus(state, { isFocus = false }) {
    state.isFocus = isFocus;
  },
  setIsShare(state, { isShare = false }) {
    state.isShare = isShare;
  },
  setModalAlertComponents(state, { modalAlertComponents }) {
    state.modalAlertComponents = modalAlertComponents;
  },
  setModalComponents(state, { modalComponents }) {
    state.modalComponents = modalComponents;
  },
  showToast(state, { message = '', duration = 1500 }) {
    state.toast = {
      isShow: true,
      message,
      duration
    };
  },
  hideToast(state) {
    state.toast = {
      ...state.toast,
      isShow: false
    };
  },
  setRouteLayout(
    state,
    {
      isHeader = undefined,
      titleName = undefined,
      isBack = undefined,
      isNav = undefined,
      isArea = undefined,
      isCart = undefined,
      isShare = undefined,
      isSearch = undefined,
      isHome = undefined,
      isQuit = undefined,
      isStore = undefined
    }
  ) {
    if (isHeader !== undefined) state.routeLayout.isHeader = isHeader;
    if (titleName !== undefined) state.routeLayout.titleName = titleName;
    if (isBack !== undefined) state.routeLayout.isBack = isBack;
    if (isNav !== undefined) state.routeLayout.isNav = isNav;
    if (isArea !== undefined) state.routeLayout.isArea = isArea;
    if (isCart !== undefined) state.routeLayout.isCart = isCart;
    if (isShare !== undefined) state.routeLayout.isShare = isShare;
    if (isSearch !== undefined) state.routeLayout.isSearch = isSearch;
    if (isHome !== undefined) state.routeLayout.isHome = isHome;
    if (isStore !== undefined) state.routeLayout.isStore = isStore;
    if (isQuit) state.routeLayout.isQuit = isQuit;
    else state.routeLayout.isQuit = false;
  },
  setTitleName(state, { titleName }) {
    console.log(titleName);
    state.routeLayout.titleName = titleName;
  },
  setKeywords(state, { keywords = [] }) {
    state.keywords = JSON.stringify(keywords);
    localStorage.keywords = JSON.stringify(keywords);
  },
  keepAlive(state, component = null) {
    state.keepAlive = component;
  },
  setScrollTop(state, top = []) {
    state.scrollTop = top;
  },
  appendScrollTop(state, top = {}) {
    state.scrollTop = [...state.scrollTop, top];
  },
  setFromStorePath(state, path = '') {
    state.fromStorePath = path;
  }
};
